import React, { Fragment, useState, useContext, useEffect } from "react";
import styled, { css } from "styled-components";

import {
  InputCopy,
  FormGroup,
  Pill,
  Breadcrumbs,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Button,
  Head,
  Card,
  Table,
  Input,
  ContentBlock,
  RadioGroup,
  ModalAlert,
  Switch,
  Icon,
  ButtonAction,
  Tag,
  Notification
} from "xsolla-uikit";

import PAh2 from '../PAh2';




import {
  PAconnectorGTM,
  PAconnectorGA,
  PAconnectorFB,
  PAconnectorPN,
  PAconnectorTW
} from "../PAconnectors";

import merge from "deepmerge";
import { IntlProvider } from "react-intl";
import PAContentBlock from "../PAContentBlock";
import { Link } from "react-router-dom";
import { CardTodo, CardSite } from "../PAcardNew";

import {
  // PAchart1,
  PAchart2
  // PAchartMap
} from "../PAchart2";



const sbVersions = [
  {
    type: 'Version before restore',
    when: "Yesterday",
    date: "06/27/19, 02:37 AM",
    who: "m.miroshnikov@xsolla.com",
    restore: "001"
  },
  {
    type: 'Published',
    when: "1 day ago",
    date: "06/27/19, 02:37 AM",
    who: "a.kozhevnikov@xsolla.com",
    restore: "002"
  },
  {
    type: 'Published',
    when: "2 day ago",
    date: "06/22/19, 02:37 AM",
    who: "m.miroshnikov@xsolla.com",
    restore: "003"
  },
  {
    type: 'Published',
    when: "2 day ago",
    date: "06/23/19, 02:37 AM",
    who: "m.miroshnikov@xsolla.com",
    restore: "004"
  }
];



export default function PAsbVersions() {

  const [restorePop, setRestorePop] = useState(false)

  return (
    <div className="">


{restorePop && (
              <ModalAlert
                // fetching={state.restorePop}
                title="Restore the older version?"
                // submitAppearance="alert"
                description="The current version will be replaced with the Version of 06/23/19, 02:37 AM"
                submit="Restore"
                discard="Cancel"
                // icon={require('./../_icons/checkmark-in-circle.svg')}
                isOpen={restorePop}
                onClose={() => setRestorePop(false)}
              />

              // <ModalAlert
              // title="Data may be lost"
              // description="If you change your secret key or Webhook URL. Do you want to proceed?"
              // discard="Discard"
              // submit="Proceed"
              // submitAppearance="alert"
              // confirmationHandler={()=>{void(0)}}
              // confirmationEl={({value, onChange}) => (
              //   <FormGroup centered={true}>
              //     <Checkbox
              //       input={{
              //         value,
              //         onChange: e => onChange(e.target.value !== 'true')
              //       }}
              //       label="Yes, I understand effect"
              //     />
              //   </FormGroup>
              // )}
              // icon={require('./../_icons/alert--red.svg')}
              // isOpen={isConfirmWithCheckboxModalOpen}
              // onClose={() => setState({restorePop: false})}
              // onSubmit={() => console.log('Confirmed!')} // eslint-disable-line
            // />

            )}



            <FormGroup>
              <CssTable>
                <CssTh
                  // className="ui-table__body__row"
                >
                  <CssRestoreTD className="xsui-table-head-cell__text">Message:</CssRestoreTD>
                  <CssRestoreTD className="xsui-table-head-cell__text">Date and time:</CssRestoreTD>
                  <CssRestoreTD className="xsui-table-head-cell__text">Action by:</CssRestoreTD>
                  <CssRestoreTD className="xsui-table-head-cell__text"></CssRestoreTD>
                </CssTh>


              {sbVersions.map(({type, when, date, who, restore}, ind)=>{
              return (

                  <CssTr
                    style={{
                      padding: '12px',
                    }}
                    className="ui-table__body__row"
                  >

                    <CssRestoreTD>
                        <CssSvnH>{type}</CssSvnH>
                    </CssRestoreTD>

                    <CssRestoreTD>
                        <div style={{
                          fontSize: 12,
                          color: 'rgb(116, 126, 138)',
                        }}>
                         {when}, {date}
                        </div>
                    </CssRestoreTD>
                    <CssRestoreTD>
                      {who}
                    </CssRestoreTD>
                    <CssRestoreTD style={{
                      justifyContent: 'flex-end',
                      }}>
                      <span style={{marginRight: 24}}><Button appearance="flatten" size="sm"><Icon name="new-tab"/>Preview</Button></span>
                      <span style={{}}>
                        <Button
                          onClick={()=>{
                            setRestorePop(true)
                          }}
                          appearance="flatten" size="sm"><Icon name="redo"/>Restore</Button>
                      </span>
                    </CssRestoreTD>

                  </CssTr>

              )
            })}
              </CssTable>
            </FormGroup>

    </div>
  )
}





const CssRestoreTD = styled.div`
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
  flex-basis: 160px;
  flex-grow: 1;
  flex-shrink: 0;
`;

const CssSvnH = styled.div`
  color: rgb(0, 36, 77);
  font-weight: bold;
  font-size: 15px;
`;

const CssTable = styled.div`
  border: none;
`;
const CssTh = styled.div`
  justify-content: flex-start;
  display: flex;
  padding: 12px;
  border: none;
  border-bottom: 1px solid #c5d0db;
  background-color: transparent;
  font-size: 13px;
  width: 100%;
  color: #747e8a;
`;
const CssTd = styled.div`
  justify-content: flex-start;
  padding: 0;
  margin: 0;
  border: none;
`;
const CssTr = styled.div`
  display: flex;
  padding: 0;
  margin: 0;
  border: 0px solid red !important;
`;

